// extracted by mini-css-extract-plugin
module.exports = {"all":"e_mp","accent":"e_np"};